import { render, staticRenderFns } from "./security.vue?vue&type=template&id=39d86948&scoped=true&"
var script = {}
import style0 from "./security.vue?vue&type=style&index=0&id=39d86948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d86948",
  null
  
)

export default component.exports